jQuery(document).ready(function(){
    function addHST() {
        // Select all relevant product titles in Product Pages, Cards, and Cart
        jQuery('.product__title, .card__heading, .cart-item__name').each(function(){
            var productTitle = jQuery(this).text().trim().toLowerCase();

            // Check if the title contains "session"
            if (productTitle.includes('session')) {
                jQuery(this).closest('.product, .card__content, .cart-item__details').find('.price-item--regular, .price-item--sale, .product-option').each(function() {
                    var priceText = jQuery(this).text().trim();

                    // Ensure "+ HST" is not added multiple times
                    if (!priceText.includes("+ HST") && priceText.match(/\$\d/)) {
                        jQuery(this).text(priceText + " + HST");
                    }
                });
            }
        });
    }

    // Run on page load
    addHST();

    // Handle AJAX-loaded products dynamically
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (jQuery(node).find('.product__title, .card__heading, .cart-item__name').length > 0) {
                    addHST();
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
